import { render } from "./Fixtures.vue?vue&type=template&id=0504c3e4"
import script from "./Fixtures.vue?vue&type=script&lang=js"
export * from "./Fixtures.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__